import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/outputs/gateway-token.model';
import { CellContext } from '@tanstack/react-table';

export interface TokenListContractCellProps
  extends CellContext<GatewayTokenModel, unknown> {}

export const TokenListContractCell = (
  props: TokenListContractCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { row } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text>{row.original.visualNumber ?? row.original.authId ?? '-'}</Text>;
};
